import { setContext } from "@apollo/client/link/context";
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";

const httpLink = createHttpLink({
  uri:
    process.env.REACT_APP_GRAPHQL_URL || "https://api.xchscan.com/v1/graphql",
});

const authLink = setContext((_, { headers }) => {
  const header = {
    headers: {
      ...headers,
    },
  };
  const secret = localStorage.getItem("auth");

  if (secret) {
    header.headers["x-hasura-admin-secret"] = secret;
  }

  return header;
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
